import type { LeaveStatus } from "../types/api";
import { statusLabels } from "../utils/format";

export default function StatusBadge({ status }: { status: LeaveStatus }) {
  return (
    <span className={`status-badge status-${status}`}>{statusLabels[status]}</span>
  );
}
